export function getCountrySettings(country) {
    var _a;
    return (_a = featuredCountrySettings[country]) !== null && _a !== void 0 ? _a : genericCountrySettings;
}
const genericCountrySettings = {
    formControls: ['address2', 'city', 'state', 'zip'],
    address2: 'Address (line 2)',
    city: 'City',
    state: 'State / Province / Territory',
    zip: 'Postal code'
};
const featuredCountryFields = ['address2', 'city', 'stateDropdown', 'zip'];
const addressLine2Optional = 'Address - line 2 (optional)';
const featuredCountrySettings = {
    US: {
        formControls: featuredCountryFields,
        address2: addressLine2Optional,
        city: 'City',
        state: 'State',
        zip: 'ZIP code'
    },
    CA: {
        formControls: featuredCountryFields,
        address2: addressLine2Optional,
        city: 'City',
        state: 'Province / Territory',
        zip: 'Postal code'
    },
    AU: {
        formControls: featuredCountryFields,
        address2: addressLine2Optional,
        city: 'City / Suburb',
        state: 'State / Territory',
        zip: 'Postcode'
    },
    NZ: {
        formControls: ['address2', 'city', 'zip'],
        address2: addressLine2Optional,
        city: 'City / Region',
        state: '',
        zip: 'Postcode'
    },
    IS: {
        formControls: ['zip', 'city'],
        address2: '',
        city: 'City',
        state: '',
        zip: 'Postal code'
    }
};
export const nonPostalCountries = [
    "AO", "AG", "AW", "BS", "BZ", "BJ", "BM", "BO", "BQ", "BW", "BF", "BI", "CM", "CF", "TD", "KM", "CG", "CD", "CK", "CI", "CW", "DJ", "DM", "GQ", "ER", "FJ", "TF", "GA", "GM", "GH", "GD", "GY", "HM", "HK", "KI", "KP", "LY", "MO", "MW", "ML", "MR", "NR", "NL", "AN", "NU", "QA", "RW", "KN", "ST", "SC", "SL", "SX", "SB", "SO", "SR", "SY", "TL", "TG", "TK", "TO", "TT", "TV", "UG", "AE", "VU", "YE", "ZW"
];
export const featuredCountries = Object.keys(featuredCountrySettings);
//# sourceMappingURL=country-settings.js.map